import api from '.'

export const accounts = {
  autoLogin (success) {
    const token = window.localStorage.getItem('auth_token')
    if (token && token.length) success(token)
  },
  enrol (token, firstName, lastName, password, termsAgreed, success, fail) {
    api.unauthenticatedRequest('POST', '/accounts/enrol', { token, firstName, lastName, password, termsAgreed }, (data) => {
      accounts.storeToken(data.token)
      success(data.token)
    }, fail)
  },

  create (email, password, firstName, lastName, termsAgreed, team, success, fail) {
    api.unauthenticatedRequest('POST', '/accounts', { email, password, firstName, lastName, termsAgreed, team }, success, fail)
  },
  login (data, success, fail) {
    api.unauthenticatedRequest('POST', '/accounts/sessions', data, (data) => {
      if (data.token) accounts.storeToken(data.token)
      success(data)
    }, fail)
  },
  storeToken (token) {
    window.localStorage.setItem('auth_token', token)
  },
  localLogout (success) {
    window.localStorage.removeItem('auth_token')
    success && success()
  },
  logout (success, fail) {
    api.authenticatedRequest('DELETE', '/accounts/sessions', null, () => {
      window.localStorage.removeItem('auth_token')
      success && success()
    }, fail)
  },
  sendPasswordResetEmail (email, success, fail) {
    api.unauthenticatedRequest('POST', '/accounts/password/reset', { email }, success, fail)
  },
  updatePasswordWithToken (token, newPassword, success, fail) {
    api.authenticatedRequest('PUT', '/accounts/password', { token, newPassword }, success, fail)
  },
  updatePassword (currentPassword, newPassword, success, fail) {
    api.authenticatedRequest('PUT', '/accounts/password', { currentPassword, newPassword }, success, fail)
  },
  delete (password, success, fail) {
    api.authenticatedRequest('DELETE', '/accounts', { password }, success, fail)
  },
  getOtpUri (success, fail) {
    api.authenticatedRequest('GET', '/accounts/otp', null, success, fail)
  },
  enableOtp (otp, password, success, fail) {
    // `password` is only needed when replacing an authenticator that already
    // works; it is omitted from the request otherwise.
    api.authenticatedRequest('POST', '/accounts/otp', password ? { otp, password } : { otp }, success, fail)
  },
  disableOtp (password, success, fail) {
    api.authenticatedRequest('DELETE', '/accounts/otp', { password }, success, fail)
  },
  regenerateRecoveryCodes (password, success, fail) {
    api.authenticatedRequest('POST', '/accounts/recoveryCodes', { password }, success, fail)
  },
  createApiToken (data, success, fail) {
    api.authenticatedRequest('POST', '/accounts/apiTokens', data, success, fail)
  },
  getApiTokens (success, fail) {
    api.authenticatedRequest('GET', '/accounts/apiTokens', null, success, fail)
  },
  deleteApiToken (tokenId, success, fail) {
    api.authenticatedRequest('DELETE', `/accounts/apiTokens/${tokenId}`, null, success, fail)
  },
  getPasskeyAuthenticationOptions (success, fail) {
    api.unauthenticatedRequest('POST', '/accounts/passkeys/authentication/options', null, success, fail)
  },
  getPasskeyRegistrationOptions (success, fail) {
    api.authenticatedRequest('POST', '/accounts/passkeys/registration/options', null, success, fail)
  },
  registerPasskey (credential, success, fail) {
    // No name is sent: the API names the passkey after the provider or
    // device that made it, and renamePasskey changes it later.
    api.authenticatedRequest('POST', '/accounts/passkeys/registration', { credential }, success, fail)
  },
  renamePasskey (passkeyId, name, success, fail) {
    api.authenticatedRequest('PATCH', `/accounts/passkeys/${passkeyId}`, { name }, success, fail)
  },
  listPasskeys (success, fail) {
    api.authenticatedRequest('GET', '/accounts/passkeys', null, success, fail)
  },
  deletePasskey (passkeyId, password, success, fail) {
    api.authenticatedRequest('DELETE', `/accounts/passkeys/${passkeyId}`, { password }, success, fail)
  }
}
